<template>
  <forms-list-activity
        v-if="!isTree"
        :form-type="formConfig.formClassLong"
        :calling-form-config="formConfig"
        ref="formList"
        :context="context"
        :filter="filter"
        :recordsWithChosenFilters="recordsWithChosenFilters"
        :filtering-mode="filteringMode"
  >
  </forms-list-activity>

  <forms-list-tree-activity
      v-else :form-type="formConfig.formClassLong"
      ref="formTree"
      :show-add="showAdd"
      :show-details="showDetails"
      :context="context"
      :filter="filter"
      :recordsWithChosenFilters="recordsWithChosenFilters"
  >
  </forms-list-tree-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import EntitiesList from "@/components/forms/EntitiesList";

import FooterButton from "@/components/navbar/FooterButton";
import FormsActions from "@/components/forms/FormsActions";
import FormsLoader from "@/components/forms/FormsLoader";
import CloseButton from "@/components/navbar/CloseButton";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsListContext from "@/activity/templates/layouts/forms/FormsListContext"
import BusinessRecord from "@/server/com/silkplm/engine/entities/BusinessRecord";
import FormsListTreeActivity from "@/activity/templates/layouts/forms/FormsListTreeActivity";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";

export default {
  name: "ActivityList",

  components: {FormsListTreeActivity, FormsListActivity, CloseButton, FooterButton, EntitiesList, VBox, FooterNavbar},
  async created(){
    this.permission = FormsLoader.formPermission(this.formConfig);

  },
  async beforeMount() {
  },

  async mounted() {
    if(this.context?.formTitle){
      this.title = this.context.formTitle;
    }
    else{
      this.title = this.formConfig?.formTitle;
    }
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      if(this.context?.formTitle){
        return this.context.formTitle;
      }
      return this.formConfig?.formTitle ?? $tr('titleInCaseOfNull','Title in case of null');
    },
  },

  props: {
    formId: {type: Number},
    formConfig: {type: BaseFormConfig},
    editInSelectMode: {default: false},
    context:{default: null},
    filter:{default: null},
    allowNoSelection: {default: null},
    recordsWithChosenFilters: {default: null},
    showAdd: {default: true},
    showDetails: {default: true},
    filteringMode: {default: false},
  },

  data: function() { return {
    selectedEntity: null,
    isTree: !!(this.formConfig?.extendedConfigs?.TreeConfig),
    /** @type{CompanyInfo[]} */
    selectedIndex: null,

    grid: null,
    permissions: new PermissionsSet(),
  }},

}
</script>
